document.addEventListener('DOMContentLoaded', function () {

  // Reviews slideshow
  var allReviews = document.querySelectorAll('.fc-review');
  var dotsWrap = document.getElementById('fc-reviews-dots');
  var prevBtn = document.getElementById('fc-reviews-prev');
  var nextBtn = document.getElementById('fc-reviews-next');
  var perPage = 3;
  var currentPage = 0;
  var totalPages = Math.ceil(allReviews.length / perPage);

  // Creează dots
  if (dotsWrap) {
    for (var d = 0; d < totalPages; d++) {
      var dot = document.createElement('span');
      dot.className = 'fc-reviews__dot' + (d === 0 ? ' active' : '');
      dot.dataset.page = d;
      dot.addEventListener('click', function() {
        goToPage(parseInt(this.dataset.page));
      });
      dotsWrap.appendChild(dot);
    }
  }

  function goToPage(page) {
    currentPage = page;
    allReviews.forEach(function(r, i) {
      if (i >= page * perPage && i < (page + 1) * perPage) {
        r.classList.add('active');
      } else {
        r.classList.remove('active');
      }
    });
    var dots = document.querySelectorAll('.fc-reviews__dot');
    dots.forEach(function(d, i) {
      d.classList.toggle('active', i === page);
    });
  }

  if (prevBtn) {
    prevBtn.addEventListener('click', function() {
      goToPage(currentPage > 0 ? currentPage - 1 : totalPages - 1);
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', function() {
      goToPage(currentPage < totalPages - 1 ? currentPage + 1 : 0);
    });
  }

  // Auto-play la 4 secunde
  setInterval(function() {
    goToPage(currentPage < totalPages - 1 ? currentPage + 1 : 0);
  }, 4000);

    // Infinite scroll coloane
  // Infinite scroll coloane
  var cols = document.querySelectorAll('.fc-showcase__col');
  var offsets = [150, 0, 150];

  window.addEventListener('load', function() {
    cols.forEach(function(col, i) {
      var half = col.scrollHeight / 2;
      var speed = i === 1 ? -0.5 : 0.5;
      var pos = -half;

      function makeAnimate(colEl, startPos, s, h, offset) {
        var p = startPos;
        function animate() {
          p += s;
          if (s > 0 && p >= 0) p = p - h;
          if (s < 0 && p <= -h) p = p + h;
          colEl.style.transform = 'translateY(' + (p + offset) + 'px)';
          requestAnimationFrame(animate);
        }
        animate();
      }

      makeAnimate(col, pos, speed, half, offsets[i]);
    });
  });
  // Particule plutitoare
  var showcase = document.querySelector('.fc-showcase');
  if (showcase) {
    var particleCount = 30;
    for (var p = 0; p < particleCount; p++) {
      var particle = document.createElement('span');
      particle.className = 'fc-particle';
      particle.innerHTML = '&nbsp;';
      var size = Math.random() * 6 + 4;
      var x = Math.random() * 100;
      var y = Math.random() * 100;
      var duration = Math.random() * 15 + 8;
      var delay = Math.random() * 10;
      var opacity = Math.random() * 0.5 + 0.5;
      particle.style.cssText = [
        'width:' + size + 'px',
        'height:' + size + 'px',
        'left:' + x + '%',
        'top:' + y + '%',
        'animation-duration:' + duration + 's',
        'animation-delay:-' + delay + 's',
        'opacity:' + opacity
      ].join(';');
      showcase.appendChild(particle);
    }
  }
  // Fade in/out la scroll
  var showcaseSection = document.querySelector('.fc-showcase');
  var showcaseInner = document.querySelector('.fc-showcase__inner');

  function handleShowcaseFade() {
    if (!showcaseSection) return;
    var rect = showcaseSection.getBoundingClientRect();
    var windowHeight = window.innerHeight;

    // Fade in cand intra in view
    if (rect.top < windowHeight * 0.85 && rect.bottom > 0) {
      var progress = Math.min(1, (windowHeight * 0.85 - rect.top) / (windowHeight * 0.3));

      if (showcaseInner) {
        showcaseInner.style.opacity = progress;
        showcaseInner.style.transform = 'translateY(' + (30 * (1 - progress)) + 'px)';
      }

      showcaseSection.style.opacity = Math.min(1, progress + 0.2);
    }

    // Fade out cand iese din view
    if (rect.bottom < windowHeight * 0.2) {
      var exitProgress = Math.max(0, rect.bottom / (windowHeight * 0.2));

      if (showcaseInner) {
        showcaseInner.style.opacity = exitProgress;
        showcaseInner.style.transform = 'translateY(' + (-20 * (1 - exitProgress)) + 'px)';
      }

      showcaseSection.style.opacity = Math.max(0.1, exitProgress);
    }
  }

  if (showcaseInner) {
    showcaseInner.style.opacity = '0';
    showcaseInner.style.transform = 'translateY(30px)';
    showcaseInner.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
  }

  if (showcaseSection) {
    showcaseSection.style.opacity = '0';
    showcaseSection.style.transition = 'opacity 0.6s ease';
  }

  window.addEventListener('scroll', handleShowcaseFade);
  handleShowcaseFade();
});